<template>
  <div class="wrapper">
    <div class="messageBar">
      <el-image fit="contain"></el-image>
      <div class="detailBar">
        <div class="title"></div>
        <div class="actBar"></div>
      </div>
    </div>
    <div class="tableBar">
      <el-tabs v-model="activeName" @tab-click="activeName = 'student'">
        <el-tab-pane label="学员" name="student">
          <div style="display: flex; justify-content: space-between">
            <div>
              <el-button
                type="primary"
                @click="
                  Object.assign(importData, $options.data().importData);
                  importData.ifShow = true;
                "
              >
                添加学员</el-button
              >
            </div>
            <div>
              <el-select
                v-model="searchCondition.status"
                @change="searchConditionChange"
              >
                <el-option value="" label="选择状态"></el-option>
                <el-option value="1" label="有效"></el-option>
                <el-option value="2" label="失效"></el-option>
              </el-select>
            </div>
          </div>
          <el-table
            :data="dataList"
            border
            style="width: calc(100% - 40px); margin: 20px"
          >
            <el-table-column prop="userName" label="学员" width="100">
            </el-table-column
            ><el-table-column prop="statusText" label="状态" width="80">
            </el-table-column
            ><el-table-column prop="learnProgress" label="学习进度" width="80">
            </el-table-column
            ><el-table-column prop="typeName" label="加入类型" width="80">
            </el-table-column
            ><el-table-column prop="createTime" label="加入时间" width="180">
            </el-table-column
            ><el-table-column prop="endTime" label="到期时间" width="180">
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="240"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="tableAct('delete', scope.row)"
                  >删除</el-button
                >
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="tableAct('edit', scope.row)"
                  >更改状态</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="getData"
            :current-page.sync="searchCondition.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="searchCondition.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchCondition.total"
          >
          </el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane label="数据分析" name="second">配置管理</el-tab-pane> -->
      </el-tabs>
    </div>
    <el-dialog
      title="批量导入"
      :visible.sync="importData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-steps :active="importData.step">
        <el-step title="上传文件"></el-step>
        <el-step title="执行导入"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div class="importStep" v-show="importData.step == 0">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">填写导入教师的信息</div>
            <div class="detail">
              请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
            </div>
            <div>
              <!-- <a href="/public/企业学员导入模板.xlsx" icon="md-album"
                >下载模板</a
              > -->

              <el-button
                type="text"
                size="mini"
                @click="download('../企业学员导入模板.xlsx')"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">上传填好的教师信息表</div>
            <div class="detail">
              文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M
            </div>
            <div>
              <el-upload
                :on-change="uploadChange"
                action="/base/common/importEnterpriceUser"
                :data="importData"
                :file-list="importData.fileList"
                :on-success="importSuccess"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-remove="
                  () => {
                    importData.fileList = [];
                  }
                "
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button type="text" size="mini">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="importStep" v-show="importData.step == 1">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次可导入数量</div>
            <div>
              <el-button type="text">{{ importData.successNum }}人</el-button>
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次不可导入数量</div>
            <div>
              <el-button type="text">{{ importData.failNum }}人</el-button>
            </div>
          </div>
        </div>
        <h3 v-if="importData.failNum > 0">不可导入列表</h3>
        <el-table
          v-if="importData.failNum > 0"
          :data="importData.failList"
          border
          style="width: calc(100% - 40px); margin: 20px"
        >
          <el-table-column
            prop="userName"
            label="行数"
            type="index"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="120">
          </el-table-column>
          <el-table-column prop="account" label="登录账号" width="160">
          </el-table-column>
          <el-table-column prop="deptName" label="部门" width="120">
          </el-table-column>
          <el-table-column prop="positionName" label="职务" width="120">
          </el-table-column>
          <el-table-column prop="moibile" label="手机" width="200">
          </el-table-column>
          <el-table-column prop="failMsg" label="错误提示" min-width="300">
          </el-table-column
        ></el-table>
      </div>
      <div class="importStep" v-show="importData.step == 2">
        <h1 style="text-align: center">批量导入完成</h1>
        <h3 style="text-align: center">
          成功导入教师数量:{{ importData.successNum }}人
        </h3>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="importData.step++"
          v-if="importData.step == 0"
          :disabled="!importData.fileList[0]"
          >下一步</el-button
        >
        <el-button
          type="primary"
          @click="doImportStudentIntoCourse"
          v-if="importData.step == 1"
          >提交并执行</el-button
        >
        <el-button
          type="primary"
          @click="importData.step = 0"
          v-if="importData.step == 1"
          plain
          >返回重新上传</el-button
        >
        <el-button
          type="primary"
          @click="importData.ifShow = false"
          v-if="importData.step == 2"
          >完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentInCourse,
  deleteStudentInCourse,
  importStudentIntoCourse,
} from "@/api/bus";

export default {
  data() {
    return {
      activeName: "student",
      searchCondition: {
        id: 0,
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      importData: {
        ifShow: false,
        isExecute: 0,
        importFile: null,
        fileList: [],
        failList: [],
        step: 0,
        failNum: 0,
        successNum: 0,
      },
      dataList: [],
    };
  },
  created() {},
  mounted() {
    this.searchCondition.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      getStudentInCourse(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    doImportStudentIntoCourse() {
      let formData = new FormData();
      formData.append("file", this.importData.fileList[0]);
      formData.append("catalog", this.$route.query.id);
      formData.append("isExecute", 1);
      importStudentIntoCourse(formData).then((data) => {
        this.importData.step = 2;
        this.getData();
      });
    },
    searchConditionChange() {
      this.searchCondition.pageNumber = 1;
      this.getData();
    },
    uploadChange(e) {
      if (e.percentage == 100) {
        this.importData.fileList = [e.raw];
      }
    },
    importSuccess(response, file, fileList) {
      this.importData.importFile = file;
      Object.assign(this.importData, response.data);
    },
    tableAct(type, item) {
      console.log(item);
      switch (type) {
        case "delete":
          this.$confirm(`确认删除吗`, "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          }).then((data) => {
            deleteStudentInCourse({ id: item.id }).then((data) => {
              this.$message.success("删除成功");
              this.getData();
              console.log(data);
            });
          });

          break;

        default:
          break;
      }
    },
    download(url) {
      location.href = url;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 20px;
}
.importStep {
  padding: 40px 0;
  .importBar {
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    margin: 20px 0;
    .iconSide {
      width: 200px;
    }
    .detailSide {
      flex: 1;
      padding: 10px 0;
      .title {
        font-size: 24px;
        line-height: 42px;
      }
      .detail {
        color: #999;
        line-height: 36px;
      }
    }
  }
}
</style>
